export function useXsrfToken() {
  return document.cookie.match(/XSRF-TOKEN=([^;]+)/)?.[1] || ""
}
